<div>
  <ng-container *ngIf="localeData.length === 1; else multiple">
    <ng-container
      *ngIf="viewable?.template"
      [ngTemplateOutlet]="viewable!.template"
      [ngTemplateOutletContext]="{
        $implicit: localeData[0]
      }"
    ></ng-container>
  </ng-container>

  <ng-template #multiple>
    <div (mouseenter)="hovered = true" (mouseleave)="hovered = false">
      <ng-container
        *ngIf="hoverable?.template"
        [ngTemplateOutlet]="hoverable!.template"
        [ngTemplateOutletContext]="{
          $implicit: localeData,
          hovered
        }"
      ></ng-container>
    </div>
  </ng-template>
</div>
